const resultPDPosition = () =>{
  console.log('resultPDPosition is running')
  const desktopSearch = document.querySelector(".desktop-search");
        const desktopSearchResutl = document.querySelector(".result-PD");
        let desktopSearchPosition = desktopSearch.getBoundingClientRect();
        let desktopSearchTop = desktopSearchPosition.top;
        desktopSearchResutl.style.top = 100 + "px";
}


const stickyTopHeaderFunction = () =>{
  if( window.pageYOffset < 200){
    document.querySelector("#shopify-section-sections--16916156317935__announcement-bar").style.position = "sticky"
    document.querySelector("#shopify-section-sections--16916156317935__announcement-bar").style.top = "0px"
      }
  document.querySelector('#shopify-section-sections--16916156317935__header').style.position = "sticky"
        const top = document.querySelector('#shopify-section-sections--16916156317935__header').getBoundingClientRect().top
       document.querySelector('#shopify-section-sections--16916156317935__header').style.top = top + "px"

  resultPDPosition();
  
}
const stickyTopHeaderFunctionFix = () =>{
  document.querySelector('#shopify-section-sections--16916156317935__header').style.position = ""
       document.querySelector('#shopify-section-sections--16916156317935__header').style.top = ""
  document.querySelector("#shopify-section-sections--16916156317935__announcement-bar").style.position = ""
    document.querySelector("#shopify-section-sections--16916156317935__announcement-bar").style.top = ""
}


// code to get custom Search and display result
const loaderForPredictive = document.querySelector('loader-for-predictive')
// geeting the search input [ "custom Search" ]
const customSearch = document.querySelector("#custom-search");
customSearch.addEventListener("click", (e) => {
    if (e.target.value != "") {
        document.querySelector('.result-PD').style.display = "block";
        document.querySelector('.overflay-for-pc').style.display = "block";
    }else{
      document.querySelector('#shopify-section-sections--16916156317935__header').style.Top = ""
    }
})

// adding Event listener to the search input

customSearch.addEventListener("input", (e) => {
    // console.log(e.target.value);
    const response = fetch(window.location.origin + `/search/suggest.json?q=${e.target.value}&resources[type]=product,page,query`).then((res) => res.json()).then((data) => {
        if (e.target.value != "") {
            document.querySelector('.overflay-for-pc').style.display = "block";
            // const header = document.querySelector('.section-header');
            // if (window.scrollY > header.clientHeight + 10) {
            //     header.style.top = '0';
            //     header.style.position = 'sticky';
            //     header.style.width = '100vw';
            // }

        } else {
            document.querySelector('.overflay-for-pc').style.display = "none";
            document.querySelector('.result-PD').style.display = "none";
            // document.querySelector('#shopify-section-sections--16916156317935__header').style.top = '';
            // document.querySelector('#shopify-section-sections--16916156317935__header').style.position = '';
            // document.querySelector('#shopify-section-sections--16916156317935__header').style.width = '';
        }
        if (data.resources.results.products.length == 0 && data.resources.results.pages.length == 0 && data.resources.results.queries.length == 0) {
            document.querySelector('.noresutlfound').style.display = 'flex';
            document.querySelector('.result-inner').style.display = 'none';
        } else {
            document.querySelector('.noresutlfound').style.display = 'none';
            document.querySelector('.result-inner').style.display = 'flex';
            getResults(data.resources.results.products, data.resources.results.pages, data.resources.results.queries, e.target.value);
        }
        console.log(data)
        return data;
    });
    // console.log(response);
})

// fucntion to get results and show in the result box

function getResults(product, pages, queries, searchfor) {

    let productPR = "";
    let pagesPR = "";
    let queriesPR = "";
    let searchforPR = ""

    // setting visibility or not visibility
    if (searchfor != "") {
        const desktopSearch = document.querySelector(".desktop-search");
        const desktopSearchResutl = document.querySelector(".result-PD");
        let desktopSearchPosition = desktopSearch.getBoundingClientRect();
        let desktopSearchTop = desktopSearchPosition.top;
        desktopSearchResutl.style.top = 100 + "px";
        desktopSearchResutl.style.display = 'block';
        document.querySelector('.loader-for-predictive').style.display = 'flex';

    } else {
        // document.querySelector('.overflay-for-pc').style.display = "none";
        const desktopSearchResutl = document.querySelector(".result-PD");
        desktopSearchResutl.style.display = 'none';
        
        document.querySelector('.loader-for-predictive').style.display = 'none';

    }



    pages.forEach(element => {
        // console.log(element.url)
        // console.log(element.handle)
        pagesPR += `<a href="${element.url}">${element.handle}</a>`
    });
    queries.forEach((element) => {
        // console.log(element.url)
        // console.log(element.styled_text)
        queriesPR += `<a href="${element.url}">${element.styled_text}</a>`
    })
    product.forEach((element) => {
        if(element.tags.includes("Parent Lisiting")){
        productPR += `<a class="flex-1-item-product" href="${element.url}">
    <img src="${element.image}" width="60px" alt="">
    <div class="title-vendor">
        <p>${element.vendor}</p>
        <div class="title-p">${element.title}</div>
    </div>
</a>`}
        searchforPR = `<a href="${window.location.origin}/search?q=${searchfor}">Search for '${searchfor}'</a> <span class="material-symbols-outlined">arrow_forward</span>`

        let PredictiveProductInnerHtml = document.querySelector('.flex-1-item.predictive-products');
        let PredictivePagesInnerHtml = document.querySelector('.flex-1-item.predictive-pages');
        let PredictiveSuggestionsInnerHtml = document.querySelector('.flex-1-item.predictive-suggestions');
        let searchfora = document.querySelector('.searchfor');
        // console.log(product.length, pages.length, queries.length, searchfor.length);
        if (product.length == 0) {
            PredictiveProductInnerHtml.style.display = 'none';
        }

        const widgets = document.querySelectorAll('.item-flex-1');
        product.length == 0 ? widgets[2].style.display = 'none' : widgets[2].style.display = 'block'
        pages.length == 0 ? widgets[1].style.display = 'none' : widgets[1].style.display = 'block'
        queries.length == 0 ? widgets[0].style.display = 'none' : widgets[0].style.display = 'block'
        // console.log(pages.length, queries.length, product.length );
        if (pages.length == 0 && queries.length == 0 && product.length > 0) {
            // console.log("running")
            document.querySelector('.flex-1-s').style.display = 'none';
            document.querySelector('.flex-1.product').style.width = "100%";

        } else {
            // console.log("jkglajkfl")
            document.querySelector('.flex-1-s').style.display = 'block';
            document.querySelector('.flex-1.product').style.width = "width: calc(60% - 25px)";
        }
        PredictivePagesInnerHtml.innerHTML = pagesPR;
        PredictiveProductInnerHtml.innerHTML = productPR;
        PredictiveSuggestionsInnerHtml.innerHTML = queriesPR;
        searchfora.innerHTML = searchforPR;
        document.querySelector('.loader-for-predictive').style.display = 'none';


    })

}

const mediaQuery = window.matchMedia('(min-width: 1026px)'); // Define a media query for window width greater than 1025px

// Function to handle clicks
function handleDocumentClick(e) {
    const searchBar = document.getElementById('custom-search');
    const resultsElements = document.querySelectorAll('.result-PD');

    // Check if the click target is not the search bar and not inside any results element
    if (e.target !== searchBar && !Array.from(resultsElements).some(element => element.contains(e.target))) {
        resultsElements.forEach(element => {
            document.querySelector('.overflay-for-pc').style.display = "none";
            document.querySelector('.result-PD').style.display = "none";
          const header = document.querySelector('.section-header');
          header.style.position = '';
                header.style.width = '';
          header.style.top = "";
          document.querySelector("#shopify-section-sections--16916156317935__announcement-bar").style.position = ""
          document.querySelector("#shopify-section-sections--16916156317935__announcement-bar").style.top = ""
        });
    }
}

// Add or remove the click event listener based on the media query
if (mediaQuery.matches) {
    document.addEventListener('click', handleDocumentClick);
} else {
    document.removeEventListener('click', handleDocumentClick);
}

